// @ts-expect-error untyped
import { Autolinker } from 'autolinker';

// We are hard-coding the autolinker instance to avoid phone links for now. In the future, we may want to
// support configuring `linkify` to allow passing options through to autolinker. At the moment, it is beneficial
// to have a single instance because we avoid wasting time setting up new autolinkers with every call.
const autolinker = new Autolinker({
  newWindow: true,
  phone: false
});

// Partial type based on autolinker source

/**
 * Parses text for linkable text and returns an array with metadata about each match. Will not
 * link phone numbers, but should work for email or URLs.
 *
 * For example:
 *
 * ```ts
 * linkify('https://example.com') // => [{ href: 'https://example.com', target: '_blank', matchedText: 'https://example.com' }]
 * linkify('test@gmail.com') // => [{ href: 'mailto:test@gmail.com', target: '_self', matchedText: 'test@gmail.com' }]
 * linkify('my website is https://hi.com') // => [{ href: 'https://hi.com', target: '_blank', matchedText: 'https://hi.com' }]
 * ```
 */
export const linkify = text => {
  const matches = autolinker.parse(text);
  return matches.map(match => ({
    href: match.getAnchorHref(),
    target: match.getType() === 'email' ? '_self' : '_blank',
    matchedText: match.matchedText,
    offset: match.offset
  }));
};